import React from "react";
import CourseList from "./components/CourseList";

function App() {
  return (
    <div className="bg-gray-100 min-h-screen">
       

      <CourseList  />
      
      
    </div>
  );
}

export default App;